import { useUser } from '@/contexts/UserContext';

export const useAdminPermissions = () => {
  const { isAdmin, isLoading } = useUser();

  return { isAdmin, isLoading };
};